import React from 'react';
import { Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1e4029] to-[#2d5f3f] text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img
              src="https://static.wixstatic.com/media/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png/v1/fill/w_212,h_93,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png"
              alt="Equi-Go Logo"
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-white/80 leading-relaxed">
              Premium self-drive horsebox hire in North Yorkshire. Safe, comfortable, 
              and reliable transport for your horse.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61580883810974"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pricing')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-white/80 hover:text-white transition-colors duration-200"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:07788754165"
                  className="flex items-start space-x-3 text-white/80 hover:text-white transition-colors duration-200 group"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
                  <span>07788 754165</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:enquiries@equi-go.co.uk"
                  className="flex items-start space-x-3 text-white/80 hover:text-white transition-colors duration-200 group break-all"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
                  <span>enquiries@equi-go.co.uk</span>
                </a>
              </li>
              <li>
                <div className="flex items-start space-x-3 text-white/80">
                  <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                  <span>
                    North Yorkshire<br />
                    Between Harrogate and Boroughbridge
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-lg font-bold mb-6">Opening Hours</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex justify-between">
                <span>Monday - Thursday</span>
                <span className="font-semibold">8am - 8pm</span>
              </li>
              <li className="flex justify-between">
                <span>Friday - Sunday</span>
                <span className="font-semibold">8am - 8pm</span>
              </li>
              <li className="flex justify-between">
                <span>Bank Holidays</span>
                <span className="font-semibold">8am - 8pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/70 text-sm">
              © {currentYear} Equi-Go Horsebox Hire. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-6 text-sm">
              <a href="/terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors duration-200">
                Terms & Conditions
              </a>
              <a href="/privacy-policy" className="text-white/70 hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="/cookie-policy" className="text-white/70 hover:text-white transition-colors duration-200">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;